var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/fa/exclamation-circle",
    stroke: "#B73721",
    strokeWidth: 1,
    fill: "#B73721",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/button-stop",
    fill: "#B73721"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.625,12 C23.625,18.4217344 18.4198594,23.625 12,23.625 C5.5801406,23.625 0.374999952,18.4217344 0.374999952,12 C0.374999952,5.5820156 5.5801406,0.374999952 12,0.374999952 C18.4198594,0.374999952 23.625,5.5820156 23.625,12 Z M12,14.34375 C10.8091406,14.34375 9.84374999,15.3091406 9.84374999,16.5 C9.84374999,17.6908594 10.8091406,18.65625 12,18.65625 C13.1908594,18.65625 14.15625,17.6908594 14.15625,16.5 C14.15625,15.3091406 13.1908594,14.34375 12,14.34375 Z M9.95282812,6.59315623 L10.3005469,12.9681563 C10.3168125,13.2664688 10.5634687,13.5 10.8622031,13.5 L13.1377969,13.5 C13.4365313,13.5 13.6831875,13.2664688 13.6994531,12.9681563 L14.0471719,6.59315623 C14.06475,6.27093748 13.8082031,5.99999997 13.4855156,5.99999997 L10.5144375,5.99999997 C10.19175,5.99999997 9.93524999,6.27093748 9.95282812,6.59315623 L9.95282812,6.59315623 Z",
    id: "exclamation-circle-solid",
    fill: "red"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.f527d6cca9642de6f1f4f611c6c513d2.svg";
export { ForwardRef as ReactComponent };